import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import { store } from './store/store';
import Notifications from 'vue-notification'
import Notificaciones from './plugins/notificaciones';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(Notificaciones)

// Vue.use(new VueSocketIO({ connection: io('http://127.0.0.1:3030'), transports: ["websocket"] })); //Develop
// Vue.use(new VueSocketIO({ connection: io('http://148.202.143.79'), transports: ["websocket"] })); //Produciton

new Vue({
    vuetify,
    router,
    store,
    iconfont: 'fa',
    render: h => h(App)
}).$mount('#app')